import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
  GridToolbarColumnsButton,
  GridToolbarExportContainer,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Themtrungtamsathach from "components/Daotaosathach/Themtrungtamsathach.js";
import Capnhattrungtamsathach from "components/Daotaosathach/Capnhattrungtamsathach.js";
import Trungtamsathachexcel from "components/Xuatexcel/Danhmuc/Trungtamsathachexcel.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  whiteSpace: "break-spaces",
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const ttcolumn = [
  { field: "id", headerName: "id", width: 100, hide: true },
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "ten",
    headerName: "Tên TT",
    width: 320,
    headerAlign: "center",
  },
  {
    field: "diachi",
    headerName: "Địa chỉ",
    width: 300,
    headerAlign: "center",
  },
  {
    field: "dienthoai",
    headerName: "Điện thoại",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "loaitrungtam",
    headerName: "Loại trung tâm",
    width: 130,
    headerAlign: "center",
  },
  {
    field: "hangxesathach",
    headerName: "Hạng xe",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "xesathach",
    headerName: "Số lượng xe",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "maytinhsathach",
    headerName: "Máy tính",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "thutruongdonvi",
    headerName: "Thủ trưởng",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "coquanquanly",
    headerName: "Cơ quan quản lý",
    width: 200,
    headerAlign: "center",
  },
];
export default function TTsathach() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [openthem, setOpenthem] = React.useState(false);
  const [trungtam, setTrungtam] = React.useState([]);
  const [cosoid, setCosoid] = React.useState(0);
  const [disableBT, setDisableBT] = React.useState(true);
  const [alert, setAlert] = React.useState(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  const [opensua, setOpensua] = React.useState(false);
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const handleClose = () => {
    setOpenthem(false);
    gettrungtamdaotao();
  };
  const handleClosesua = () => {
    setOpensua(false);
    gettrungtamdaotao();
  };
  const openthembc = () => {
    setOpenthem(true);
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
        <GridToolbarColumnsButton />
        <GridToolbarExportContainer>
          <Trungtamsathachexcel />
        </GridToolbarExportContainer>
      </Box>
    );
  };
  const gettrungtamdaotao = () => {
    var url =
      Config.backend + "/api/Donvi/gettrungtamsathach?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTrungtam(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoabaocao = () => {
    var url = Config.backend + "/api/CoSoGTVT/xoattsathach";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: cosoid,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
          gettrungtamdaotao();
          setDisableBT(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  React.useEffect(() => {
    gettrungtamdaotao();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "12%" }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 27 }}
            onClick={openthembc}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="error"
            variant="contained"
            style={{ height: 27 }}
            disabled={disableBT}
            onClick={xoabaocao}
          >
            Xóa
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={trungtam}
            columns={ttcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              setDisableBT(false);
              setCosoid(Number(params.row.id));
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setOpensua(true);
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm trung tâm sát hạch
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themtrungtamsathach />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opensua}
          onClose={handleClosesua}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật trung tâm sát hạch
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosesua} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhattrungtamsathach id={cosoid} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
